/**
 * Created by Carsten Bühler
 * User: CBuehler on 28.01.2016
 * Copyright: xdot GmbH 2015
 */

import JournalStore from './JournalStore';

let journalStoreInstance;

export function getJournalStore(AppContext) {
    return journalStoreInstance || (journalStoreInstance = AppContext.createStore(JournalStore));
}



// WEBPACK FOOTER //
// ./js/stores/StoreFactory.js